export default __webpack_public_path__ + "static/marksun-89da48d3fdb828e10aae217f4db168c8.png";